//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */
import window from "../../util/window";
import RasterTileSource from "../../source/raster_tile_source";
import { LercDecode } from "./lercdecode";
import { isByteType, isImgType } from "./util";
import { Evented } from '../../util/evented';

import type {Source} from '../../source/source';
import type Dispatcher from '../../util/dispatcher';
import type Tile from '../../source/tile';

class LercTileSource extends RasterTileSource implements Source  {
    headers: Object;
    tileType: string | boolean;
    lercVersion: number;
    _decode: typeof LercDecode;

    constructor(id: string, options: any, dispatcher: Dispatcher, eventedParent: Evented) {
        super(id, options, dispatcher, eventedParent);
        this.headers = options.headers;
        this.tileType = options.tileType || false;
        this.lercVersion = options.lercVersion || 2;
        this._decode = options.decode || LercDecode;
    }
    loadTile(tile: Tile, callback: Function) {
        let url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme), this.url, this.tileSize);

        if (this.lercVersion === 1) {
            url = this.setLercV1Url(tile, url);
        }
        this.type

        if (this.tileType === "arcgis") url = this.setArcgisUrl(tile);
        const headers = this.headers;
        const requestParameters = {
            url,
            headers,
        };
        const params = {
            request: requestParameters,
            uid: tile.uid,
            type: "lercv2",
            source: this.id,
            url: url,
            decodeType: this._decode.type,
        };
        
        if (!tile.actor || tile.state === 'expired') {
            tile.actor = this.dispatcher.getActor();
            tile.request = tile.actor.send('loadTile', params, done.bind(this));
        } else if (tile.state === 'loading') {
            // schedule tile reloading after it has been loaded
            tile.reloadCallback = callback;
        } else {
            tile.request = tile.actor.send('reloadTile', params, done.bind(this));
        }
        
        function done(err, img) {
            if (tile.aborted) {
                tile.state = "unloaded";
                return callback(null);
            }

            if (err) {
                tile.state = "errored";
                return callback(err);
            }
            if (this.map._refreshExpiredTiles) tile.setExpiryData(img);
            delete img.cacheControl;
            delete img.expires;
            const dataDecode = this._decode;
            // const dataDecode = this._decode;
            // if (dataDecode.verify && !dataDecode.verify(img)) {
            //     tile.state = "errored";
            //     return callback("tile data verify err");
            // }
            if (dataDecode.type === "img") {
                if (dataDecode.verify && !dataDecode.verify(img)) {
                    tile.state = "errored";
                    return callback("tile data verify err");
                }
                dataDecode.decode(img, lerc => {
                    this.loadImgData2Texture(tile, lerc, callback);
                });
            } else if (dataDecode.type === "buffer") {
                this.loadBufferData2Texture(tile, img, callback);
                // dataDecode.decode(img, lerc => {
                //     this.loadBufferData2Texture(tile, lerc, callback);
                // });
            }
        }
        // tile.request = ajax.getArrayBuffer(requestParameters, done.bind(this), this.headers);

        // // tile.request = ajax.getArrayBuffer(url, done.bind(this));

        // function done(err, img) {
        //     delete tile.request;

        //     if (tile.aborted) {
        //         tile.state = "unloaded";
        //         return callback(null);
        //     }

        //     if (err) {
        //         tile.state = "errored";
        //         return callback(err);
        //     }
        //     if (this.map._refreshExpiredTiles) tile.setExpiryData(img);
        //     delete img.cacheControl;
        //     delete img.expires;
        //     const dataDecode = this._decode;
        //     if (dataDecode.verify && !dataDecode.verify(img)) {
        //         tile.state = "errored";
        //         return callback("tile data verify err");
        //     }
        //     if (dataDecode.type === 'img') {
        //         dataDecode.decode(img, (lerc) => {
        //             this.loadImgData2Texture(tile, lerc, callback);
        //         });
        //     } else if (dataDecode.type === 'buffer') {
        //         dataDecode.decode(img, (lerc) => {
        //             this.loadBufferData2Texture(tile, lerc, callback);
        //         });
        //     }
        // }
    }
    loadBufferData2Texture(tile: Tile, lerc: any, callback: Function) {
        const gl = this.map.painter.context.gl;
        tile.lerc = lerc.data;
        const { glenum, dataType, ArrayType = "Float32Array", width = 256, height = 256, border = 0, data } = lerc;

        if (!tile.lerc) {
            tile.state = "errored";
            return callback("tile data decode err");
        }
        if(gl.isWebgl2){
            tile.texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            if (isByteType(dataType)) {
                this.map.painter.context.pixelStoreUnpack.set(1);
            }
            if(ArrayType == "Float32Array"){
                gl.texImage2D(
                    gl.TEXTURE_2D,
                    0,
                    gl.R32F,
                    width,
                    height,
                    border,
                    gl.RED,
                    gl[dataType],
                    new window[ArrayType](data),
                );
            }else{
                gl.texImage2D(
                    gl.TEXTURE_2D,
                    0,
                    gl[glenum],
                    width,
                    height,
                    border,
                    gl[glenum],
                    gl[dataType],
                    new window[ArrayType](data),
                );
            }
        }else{
            const floatTextures = gl.getExtension("OES_texture_float");
            if (!floatTextures) {
                return callback("no floating point texture support");
            }
            tile.texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            if (isByteType(dataType)) {
                this.map.painter.context.pixelStoreUnpack.set(1);
            }
            gl.texImage2D(
                gl.TEXTURE_2D,
                0,
                gl[glenum],
                width,
                height,
                border,
                gl[glenum],
                gl[dataType],
                new window[ArrayType](data),
            );
        }
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        if (this.map.painter.extTextureFilterAnisotropic) {
            gl.texParameterf(
                gl.TEXTURE_2D,
                this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,
                this.map.painter.extTextureFilterAnisotropicMax,
            );
        }
        tile.texture.size = lerc.width;
        if(gl.isWebgl2){
        }else{
            gl.generateMipmap(gl.TEXTURE_2D);
        }
        tile.state = "loaded";
        callback(null);
    }
    loadImgData2Texture(tile: Tile, lerc: any, callback: Function) {
        const gl = this.map.painter.context.gl;
        const { glenum, dataType, data } = lerc;
        if (!isImgType(data)) {
            tile.state = "errored";
            return callback(
                `layer.${
                    this.id
                }: data is not a img type. It should be one of HTMLImageElement ,HTMLCanvasElement, HTMLVideoElement, ImageData`,
            );
        }
        tile.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, tile.texture);
        if (isByteType(dataType)) {
            this.map.painter.context.pixelStoreUnpack.set(1);
        }
        gl.texImage2D(gl.TEXTURE_2D, 0, gl[glenum], gl[glenum], gl[dataType], data);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        if (this.map.painter.extTextureFilterAnisotropic) {
            gl.texParameterf(
                gl.TEXTURE_2D,
                this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,
                this.map.painter.extTextureFilterAnisotropicMax,
            );
        }
        tile.texture.size = lerc.width;
        gl.generateMipmap(gl.TEXTURE_2D);
        tile.state = "loaded";
        callback(null);
    }

    setLercV1Url(tile: Tile, url: string) {
        let z = tile.tileID.canonical.z,
            y = tile.tileID.canonical.y.toString(16),
            x = tile.tileID.canonical.x.toString(16);
        if (z < 10) z = `0${z}`;
        const rLength = y.length; // row è¡å·

        if (rLength < 8) {
            for (let i = 0; i < 8 - rLength; i++) {
                y = `0${y}`;
            }
        }
        const r = `R${y}`;
        const cLength = x.length;
        if (cLength < 8) {
            for (let i = 0; i < 8 - cLength; i++) {
                x = `0${x}`;
            }
        }
        const c = `C${x}`; // æ ¹
        // const url = `http://101.201.77.235:8080/L${z}/${r}/${c}.lerc`;
        const sUrl = `${url}L${z}/${r}/${c}.lerc`;

        return sUrl;
    }

    setArcgisUrl(tile: Tile) {
        let z = tile.tileID.canonical.z,
            y = tile.tileID.canonical.y.toString(16),
            x = tile.tileID.canonical.x.toString(16);
        if (z < 10) z = `0${z}`;
        const rLength = y.length; // row è¡å·

        if (rLength < 8) {
            for (let i = 0; i < 8 - rLength; i++) {
                y = `0${y}`;
            }
        }
        const r = `R${y}`;
        const cLength = x.length;
        if (cLength < 8) {
            for (let i = 0; i < 8 - cLength; i++) {
                x = `0${x}`;
            }
        }
        const c = `C${x}`; // æ ¹
        const url = `http://101.201.77.235:8080/L${z}/${r}/${c}.lerc`;
        return url;
    }
    unloadTile(tile: Tile) {
        if (tile.texture) this.map.painter.context.gl.deleteTexture(tile.texture);
    }
}

export default LercTileSource;
